"use strict";
// ===========================================================================
// DO NOT EDIT THIS FILE MANUALLY!
//
// The contents have been added automatically.
// See: scripts/generate-chains.ts for more information
// ===========================================================================
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHAINS = void 0;
exports.CHAINS = [
    {
        alias: 'apechain-arbitrum-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://curtis.explorer.caldera.xyz/api' },
            browserUrl: 'https://curtis.explorer.caldera.xyz/',
        },
        id: '33111',
        name: 'ApeChain testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://curtis.rpc.caldera.xyz/http' }],
        symbol: 'APE',
        testnet: true,
    },
    {
        alias: 'apechain',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api.apescan.io/api' },
            browserUrl: 'https://apescan.io/',
        },
        id: '33139',
        name: 'ApeChain',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.apechain.com/http' },
            { alias: 'public', rpcUrl: 'https://apechain.calderachain.xyz/http' },
            { alias: 'alchemy', homepageUrl: 'https://alchemy.com' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
        ],
        symbol: 'APE',
        testnet: false,
    },
    {
        alias: 'arbitrum-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: {
                key: { hardhatEtherscanAlias: 'arbitrumSepolia', required: true },
                url: 'https://api-sepolia.arbiscan.io/api',
            },
            browserUrl: 'https://sepolia.arbiscan.io/',
        },
        id: '421614',
        name: 'Arbitrum testnet',
        providers: [
            { alias: 'default', rpcUrl: 'https://sepolia-rollup.arbitrum.io/rpc' },
            { alias: 'publicnode', rpcUrl: 'https://arbitrum-sepolia-rpc.publicnode.com' },
        ],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'arbitrum',
        decimals: 18,
        explorer: {
            api: { key: { hardhatEtherscanAlias: 'arbitrumOne', required: true }, url: 'https://api.arbiscan.io/api' },
            browserUrl: 'https://arbiscan.io/',
        },
        id: '42161',
        name: 'Arbitrum One',
        providers: [
            { alias: 'default', rpcUrl: 'https://arb1.arbitrum.io/rpc' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
            { alias: 'quicknode', homepageUrl: 'https://quicknode.com' },
            { alias: 'reblok', homepageUrl: 'https://reblok.io' },
        ],
        symbol: 'ETH',
        testnet: false,
    },
    {
        alias: 'atleta-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://blockscout.testnet-v2.atleta.network/api' },
            browserUrl: 'https://blockscout.testnet-v2.atleta.network/',
        },
        id: '2340',
        name: 'Atleta testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://rpc.testnet-v2.atleta.network' }],
        symbol: 'ATLA',
        testnet: true,
    },
    {
        alias: 'avalanche-testnet',
        decimals: 18,
        explorer: {
            api: {
                key: { hardhatEtherscanAlias: 'avalancheFujiTestnet', required: true },
                url: 'https://api.routescan.io/v2/network/testnet/evm/43113/etherscan/api',
            },
            browserUrl: 'https://testnet.snowtrace.io/',
        },
        id: '43113',
        name: 'Avalanche testnet',
        providers: [
            { alias: 'default', rpcUrl: 'https://api.avax-test.network/ext/bc/C/rpc' },
            { alias: 'publicnode', rpcUrl: 'https://avalanche-fuji-c-chain-rpc.publicnode.com' },
        ],
        symbol: 'AVAX',
        testnet: true,
    },
    {
        alias: 'avalanche',
        decimals: 18,
        explorer: {
            api: {
                key: { hardhatEtherscanAlias: 'avalanche', required: true },
                url: 'https://api.routescan.io/v2/network/mainnet/evm/43114/etherscan/api',
            },
            browserUrl: 'https://snowtrace.io/',
        },
        id: '43114',
        name: 'Avalanche',
        providers: [
            { alias: 'default', rpcUrl: 'https://api.avax.network/ext/bc/C/rpc' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
            { alias: 'quicknode', homepageUrl: 'https://quicknode.com' },
            { alias: 'reblok', homepageUrl: 'https://reblok.io' },
        ],
        symbol: 'AVAX',
        testnet: false,
    },
    {
        alias: 'base-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api-sepolia.basescan.org/api' },
            browserUrl: 'https://sepolia.basescan.org/',
        },
        id: '84532',
        name: 'Base testnet',
        providers: [
            { alias: 'default', rpcUrl: 'https://sepolia.base.org' },
            { alias: 'publicnode', rpcUrl: 'https://base-sepolia-rpc.publicnode.com' },
        ],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'base',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api.basescan.org/api' },
            browserUrl: 'https://basescan.org/',
        },
        id: '8453',
        name: 'Base',
        providers: [
            { alias: 'default', rpcUrl: 'https://mainnet.base.org' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
            { alias: 'quicknode', homepageUrl: 'https://quicknode.com' },
            { alias: 'reblok', homepageUrl: 'https://reblok.io' },
        ],
        symbol: 'ETH',
        testnet: false,
    },
    {
        alias: 'berachain-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://api.routescan.io/v2/network/testnet/evm/80069/etherscan/api' },
            browserUrl: 'https://bepolia.beratrail.io/',
        },
        id: '80069',
        name: 'Berachain testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://bepolia.rpc.berachain.com/' }],
        symbol: 'BERA',
        testnet: true,
    },
    {
        alias: 'berachain',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api.berascan.com/api' },
            browserUrl: 'https://berascan.com/',
        },
        id: '80094',
        name: 'Berachain',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.berachain.com/' },
            { alias: 'publicnode', rpcUrl: 'https://berachain-rpc.publicnode.com' },
            { alias: 'alchemy', homepageUrl: 'https://alchemy.com' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
            { alias: 'quicknode', homepageUrl: 'https://quicknode.com' },
        ],
        symbol: 'BERA',
        testnet: false,
    },
    {
        alias: 'bitlayer-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://api-testnet.btrscan.com/scan/api' },
            browserUrl: 'https://testnet.btrscan.com/',
        },
        id: '200810',
        name: 'Bitlayer testnet',
        providers: [
            { alias: 'default', rpcUrl: 'https://testnet-rpc.bitlayer.org' },
            { alias: 'public', rpcUrl: 'https://testnet-rpc.bitlayer-rpc.com' },
        ],
        symbol: 'BTC',
        testnet: true,
    },
    {
        alias: 'bitlayer',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://api.btrscan.com/scan/api' },
            browserUrl: 'https://www.btrscan.com/',
        },
        id: '200901',
        name: 'Bitlayer',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.bitlayer.org' },
            { alias: 'public', rpcUrl: 'https://rpc.bitlayer-rpc.com' },
            { alias: 'rockx', homepageUrl: 'https://rockx.com/' },
        ],
        symbol: 'BTC',
        testnet: false,
    },
    {
        alias: 'blast-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api-sepolia.blastscan.io/api' },
            browserUrl: 'https://sepolia.blastscan.io/',
        },
        id: '168587773',
        name: 'Blast testnet',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.ankr.com/blast_testnet_sepolia' },
            { alias: 'public', rpcUrl: 'https://sepolia.blast.io' },
        ],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'blast',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api.blastscan.io/api' },
            browserUrl: 'https://blastscan.io/',
        },
        id: '81457',
        name: 'Blast',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.blast.io' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
            { alias: 'quicknode', homepageUrl: 'https://quicknode.com' },
            { alias: 'reblok', homepageUrl: 'https://reblok.io' },
        ],
        symbol: 'ETH',
        testnet: false,
    },
    {
        alias: 'bob-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://bob-sepolia.explorer.gobob.xyz/api' },
            browserUrl: 'https://bob-sepolia.explorer.gobob.xyz/',
        },
        id: '808813',
        name: 'BOB testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://bob-sepolia.rpc.gobob.xyz/' }],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'bob',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://explorer.gobob.xyz/api' },
            browserUrl: 'https://explorer.gobob.xyz/',
        },
        id: '60808',
        name: 'BOB',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.gobob.xyz/' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
            { alias: 'tenderly', homepageUrl: 'https://tenderly.co/' },
        ],
        symbol: 'ETH',
        testnet: false,
    },
    {
        alias: 'bsc-testnet',
        decimals: 18,
        explorer: {
            api: { key: { hardhatEtherscanAlias: 'bscTestnet', required: true }, url: 'https://api-testnet.bscscan.com/api' },
            browserUrl: 'https://testnet.bscscan.com/',
        },
        id: '97',
        name: 'BNB Smart Chain testnet',
        providers: [
            { alias: 'default', rpcUrl: 'https://data-seed-prebsc-1-s3.binance.org:8545/' },
            { alias: 'publicnode', rpcUrl: 'https://bsc-testnet-rpc.publicnode.com' },
        ],
        symbol: 'BNB',
        testnet: true,
    },
    {
        alias: 'bsc',
        decimals: 18,
        explorer: {
            api: { key: { hardhatEtherscanAlias: 'bsc', required: true }, url: 'https://api.bscscan.com/api' },
            browserUrl: 'https://bscscan.com/',
        },
        id: '56',
        name: 'BNB Smart Chain',
        providers: [
            { alias: 'default', rpcUrl: 'https://bsc-dataseed1.binance.org/' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
            { alias: 'quicknode', homepageUrl: 'https://quicknode.com' },
            { alias: 'reblok', homepageUrl: 'https://reblok.io' },
        ],
        symbol: 'BNB',
        testnet: false,
    },
    {
        alias: 'core-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api.test.btcs.network/api' },
            browserUrl: 'https://scan.test.btcs.network/',
        },
        id: '1115',
        name: 'Core testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://rpc.test.btcs.network/' }],
        symbol: 'CORE',
        testnet: true,
    },
    {
        alias: 'core',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://openapi.coredao.org/api' },
            browserUrl: 'https://scan.coredao.org/',
        },
        id: '1116',
        name: 'Core',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.coredao.org/' },
            { alias: 'icecreamswap', rpcUrl: 'https://rpc-core.icecreamswap.com/' },
            { alias: 'infstones', homepageUrl: 'https://infstones.com' },
        ],
        symbol: 'CORE',
        testnet: false,
    },
    {
        alias: 'ethereum-holesky-testnet',
        decimals: 18,
        explorer: {
            api: { key: { hardhatEtherscanAlias: 'holesky', required: true }, url: 'https://api-holesky.etherscan.io/api' },
            browserUrl: 'https://holesky.etherscan.io/',
        },
        id: '17000',
        name: 'Ethereum Holesky testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://ethereum-holesky-rpc.publicnode.com' }],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'ethereum-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { hardhatEtherscanAlias: 'sepolia', required: true }, url: 'https://api-sepolia.etherscan.io/api' },
            browserUrl: 'https://sepolia.etherscan.io/',
        },
        id: '11155111',
        name: 'Ethereum Sepolia testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://ethereum-sepolia-rpc.publicnode.com' }],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'ethereum',
        decimals: 18,
        explorer: {
            api: { key: { hardhatEtherscanAlias: 'mainnet', required: true }, url: 'https://api.etherscan.io/api' },
            browserUrl: 'https://etherscan.io/',
        },
        id: '1',
        name: 'Ethereum',
        providers: [
            { alias: 'default', rpcUrl: 'https://ethereum-rpc.publicnode.com' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
            { alias: 'quicknode', homepageUrl: 'https://quicknode.com' },
            { alias: 'reblok', homepageUrl: 'https://reblok.io' },
        ],
        symbol: 'ETH',
        testnet: false,
    },
    {
        alias: 'fraxtal-holesky-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api-holesky.fraxscan.com/api/' },
            browserUrl: 'https://holesky.fraxscan.com/',
        },
        id: '2522',
        name: 'Fraxtal testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://rpc.testnet.frax.com' }],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'fraxtal',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api.fraxscan.com/api/' },
            browserUrl: 'https://fraxscan.com/',
        },
        id: '252',
        name: 'Fraxtal',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.frax.com' },
            { alias: 'publicnode', rpcUrl: 'https://fraxtal-rpc.publicnode.com:443' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
            { alias: 'tenderly', homepageUrl: 'https://tenderly.co/' },
            { alias: 'reblok', homepageUrl: 'https://reblok.io' },
        ],
        symbol: 'FXS',
        testnet: false,
    },
    {
        alias: 'gnosis-testnet',
        decimals: 18,
        explorer: {
            api: {
                key: { hardhatEtherscanAlias: 'chiado', required: false },
                url: 'https://gnosis-chiado.blockscout.com/api',
            },
            browserUrl: 'https://gnosis-chiado.blockscout.com/',
        },
        id: '10200',
        name: 'Gnosis Chain testnet',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.chiadochain.net' },
            { alias: 'publicnode', rpcUrl: 'https://gnosis-chiado-rpc.publicnode.com' },
        ],
        symbol: 'xDAI',
        testnet: true,
    },
    {
        alias: 'gnosis',
        decimals: 18,
        explorer: {
            api: { key: { hardhatEtherscanAlias: 'xdai', required: true }, url: 'https://api.gnosisscan.io/api' },
            browserUrl: 'https://gnosisscan.io/',
        },
        id: '100',
        name: 'Gnosis Chain',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.gnosischain.com' },
            { alias: 'publicnode', rpcUrl: 'https://gnosis-rpc.publicnode.com/' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
            { alias: 'quicknode', homepageUrl: 'https://quicknode.com' },
        ],
        symbol: 'xDAI',
        testnet: false,
    },
    {
        alias: 'inevm-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://testnet.explorer.inevm.com/api' },
            browserUrl: 'https://testnet.explorer.inevm.com/',
        },
        id: '2424',
        name: 'inEVM testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://testnet.rpc.inevm.com/http' }],
        symbol: 'INJ',
        testnet: true,
    },
    {
        alias: 'inevm',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://explorer.inevm.com/api' },
            browserUrl: 'https://explorer.inevm.com/',
        },
        id: '2525',
        name: 'inEVM',
        providers: [{ alias: 'default', rpcUrl: 'https://mainnet.rpc.inevm.com/http' }],
        symbol: 'INJ',
        testnet: false,
    },
    {
        alias: 'ink-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://explorer-sepolia.inkonchain.com/api' },
            browserUrl: 'https://explorer-sepolia.inkonchain.com/',
        },
        id: '763373',
        name: 'Ink testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://rpc-qnd-sepolia.inkonchain.com' }],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'ink',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://explorer.inkonchain.com/api' },
            browserUrl: 'https://explorer.inkonchain.com/',
        },
        id: '57073',
        name: 'Ink',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc-gel.inkonchain.com' },
            { alias: 'public', rpcUrl: 'https://rpc-qnd.inkonchain.com' },
            { alias: 'tenderly', homepageUrl: 'https://tenderly.co/' },
            { alias: 'alchemy', homepageUrl: 'https://alchemy.com' },
            { alias: 'quicknode', homepageUrl: 'https://quicknode.com' },
        ],
        symbol: 'ETH',
        testnet: false,
    },
    {
        alias: 'kava-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://api.verify.mintscan.io/evm/api/0x8ad' },
            browserUrl: 'https://testnet.kavascan.com/',
        },
        id: '2221',
        name: 'Kava testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://evm.testnet.kava.io/' }],
        symbol: 'KAVA',
        testnet: true,
    },
    {
        alias: 'kava',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://api.verify.mintscan.io/evm/api/0x8ae' },
            browserUrl: 'https://kavascan.com/',
        },
        id: '2222',
        name: 'Kava',
        providers: [
            { alias: 'default', rpcUrl: 'https://evm.kava.io/' },
            { alias: 'publicnode', rpcUrl: 'https://kava-evm-rpc.publicnode.com/' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org/' },
        ],
        symbol: 'KAVA',
        testnet: false,
    },
    {
        alias: 'kroma-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api-sepolia.kromascan.com/api' },
            browserUrl: 'https://sepolia.kromascan.com/',
        },
        id: '2358',
        name: 'Kroma testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://api.sepolia.kroma.network/' }],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'kroma',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://api.routescan.io/v2/network/mainnet/evm/255/etherscan' },
            browserUrl: 'https://kroscan.io/',
        },
        id: '255',
        name: 'Kroma',
        providers: [
            { alias: 'default', rpcUrl: 'https://api.kroma.network/' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
            { alias: 'rockx', homepageUrl: 'https://rockx.com/' },
        ],
        symbol: 'ETH',
        testnet: false,
    },
    {
        alias: 'lightlink-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://pegasus.lightlink.io/api' },
            browserUrl: 'https://pegasus.lightlink.io/',
        },
        id: '1891',
        name: 'LightLink testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://replicator.pegasus.lightlink.io/rpc/v1' }],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'lightlink',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://phoenix.lightlink.io/api' },
            browserUrl: 'https://phoenix.lightlink.io/',
        },
        id: '1890',
        name: 'LightLink',
        providers: [
            { alias: 'default', rpcUrl: 'https://replicator.phoenix.lightlink.io/rpc/v1' },
            { alias: 'omniatech', rpcUrl: 'https://endpoints.omniatech.io/v1/lightlink/phoenix/public' },
        ],
        symbol: 'ETH',
        testnet: false,
    },
    {
        alias: 'linea-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api-sepolia.lineascan.build/api/' },
            browserUrl: 'https://sepolia.lineascan.build/',
        },
        id: '59141',
        name: 'Linea testnet',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.sepolia.linea.build' },
            { alias: 'publicnode', rpcUrl: 'https://linea-sepolia-rpc.publicnode.com' },
        ],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'linea',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api.lineascan.build/api' },
            browserUrl: 'https://lineascan.build/',
        },
        id: '59144',
        name: 'Linea',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.linea.build' },
            { alias: 'publicnode', rpcUrl: 'https://linea-rpc.publicnode.com' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org/' },
            { alias: 'reblok', homepageUrl: 'https://reblok.io' },
        ],
        symbol: 'ETH',
        testnet: false,
    },
    {
        alias: 'lumia-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://testnet-explorer.lumia.org/api/' },
            browserUrl: 'https://testnet-explorer.lumia.org/',
        },
        id: '1952959480',
        name: 'Lumia testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://testnet-rpc.lumia.org' }],
        symbol: 'LUMIA',
        testnet: true,
    },
    {
        alias: 'lumia',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://explorer.lumia.org/api/' },
            browserUrl: 'https://explorer.lumia.org/',
        },
        id: '994873017',
        name: 'Lumia',
        providers: [
            { alias: 'default', rpcUrl: 'https://mainnet-rpc.lumia.org' },
            { alias: 'alchemy', homepageUrl: 'https://alchemy.com' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'nirvanalabs', homepageUrl: 'https://nirvanalabs.com' },
        ],
        symbol: 'LUMIA',
        testnet: false,
    },
    {
        alias: 'manta-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://pacific-explorer.sepolia-testnet.manta.network/api/' },
            browserUrl: 'https://pacific-explorer.sepolia-testnet.manta.network/',
        },
        id: '3441006',
        name: 'Manta testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://pacific-rpc.sepolia-testnet.manta.network/http' }],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'manta',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://pacific-explorer.manta.network/api/' },
            browserUrl: 'https://pacific-explorer.manta.network/',
        },
        id: '169',
        name: 'Manta',
        providers: [
            { alias: 'default', rpcUrl: 'https://pacific-rpc.manta.network/http' },
            { alias: 'public', rpcUrl: 'https://r1.pacific.manta.systems/http' },
            { alias: 'nirvanalabs', rpcUrl: 'https://manta.nirvanalabs.xyz/mantapublic' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
        ],
        symbol: 'ETH',
        testnet: false,
    },
    {
        alias: 'mantle-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api-sepolia.mantlescan.xyz/api' },
            browserUrl: 'https://sepolia.mantlescan.xyz/',
        },
        id: '5003',
        name: 'Mantle testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://rpc.sepolia.mantle.xyz' }],
        symbol: 'MNT',
        testnet: true,
    },
    {
        alias: 'mantle',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api.mantlescan.xyz/api' },
            browserUrl: 'https://mantlescan.xyz/',
        },
        id: '5000',
        name: 'Mantle',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.mantle.xyz' },
            { alias: 'publicnode', rpcUrl: 'https://mantle-rpc.publicnode.com' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'quicknode', homepageUrl: 'https://quicknode.com' },
            { alias: 'reblok', homepageUrl: 'https://reblok.io' },
        ],
        symbol: 'MNT',
        testnet: false,
    },
    {
        alias: 'megaeth-testnet',
        decimals: 18,
        explorer: { browserUrl: 'https://www.megaexplorer.xyz/' },
        id: '6342',
        name: 'MegaETH testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://carrot.megaeth.com/rpc' }],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'merlin-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://testnet-scan.merlinchain.io/api' },
            browserUrl: 'https://testnet-scan.merlinchain.io/',
        },
        id: '686868',
        name: 'Merlin testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://testnet-rpc.merlinchain.io' }],
        symbol: 'BTC',
        testnet: true,
    },
    {
        alias: 'merlin',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://scan.merlinchain.io/api' },
            browserUrl: 'https://scan.merlinchain.io/',
        },
        id: '4200',
        name: 'Merlin',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.merlinchain.io' },
            { alias: 'blockpi', homepageUrl: 'https://blockpi.io' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org/' },
        ],
        symbol: 'BTC',
        testnet: false,
    },
    {
        alias: 'metal',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://explorer.metall2.com/api' },
            browserUrl: 'https://explorer.metall2.com/',
        },
        id: '1750',
        name: 'Metal L2',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.metall2.com/' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
        ],
        symbol: 'ETH',
        testnet: false,
    },
    {
        alias: 'metis-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://sepolia-explorer-api.metisdevops.link/api' },
            browserUrl: 'https://sepolia-explorer.metisdevops.link/',
        },
        id: '59902',
        name: 'Metis testnet',
        providers: [
            { alias: 'default', rpcUrl: 'https://sepolia.metisdevops.link' },
            { alias: 'publicnode', rpcUrl: 'https://metis-sepolia-rpc.publicnode.com:443' },
        ],
        symbol: 'METIS',
        testnet: true,
    },
    {
        alias: 'metis',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://andromeda-explorer.metis.io/api' },
            browserUrl: 'https://andromeda-explorer.metis.io/',
        },
        id: '1088',
        name: 'Metis',
        providers: [
            { alias: 'default', rpcUrl: 'https://andromeda.metis.io/?owner=1088' },
            { alias: 'publicnode', rpcUrl: 'https://metis-rpc.publicnode.com:443' },
            { alias: 'alchemy', homepageUrl: 'https://alchemy.com' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
        ],
        symbol: 'METIS',
        testnet: false,
    },
    {
        alias: 'mode-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://sepolia.explorer.mode.network/api/' },
            browserUrl: 'https://sepolia.explorer.mode.network/',
        },
        id: '919',
        name: 'Mode testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://sepolia.mode.network' }],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'mode',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://explorer.mode.network/api/' },
            browserUrl: 'https://explorer.mode.network/',
        },
        id: '34443',
        name: 'Mode',
        providers: [
            { alias: 'default', rpcUrl: 'https://mainnet.mode.network' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org/' },
            { alias: 'tenderly', homepageUrl: 'https://tenderly.co/' },
        ],
        symbol: 'ETH',
        testnet: false,
    },
    {
        alias: 'monad-testnet',
        decimals: 18,
        explorer: { browserUrl: 'https://testnet.monadexplorer.com/' },
        id: '10143',
        name: 'Monad testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://testnet-rpc.monad.xyz/' }],
        symbol: 'MON',
        testnet: true,
    },
    {
        alias: 'moonbeam-testnet',
        decimals: 18,
        explorer: {
            api: {
                key: { hardhatEtherscanAlias: 'moonbaseAlpha', required: true },
                url: 'https://api-moonbase.moonscan.io/api',
            },
            browserUrl: 'https://moonbase.moonscan.io/',
        },
        id: '1287',
        name: 'Moonbeam testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://rpc.api.moonbase.moonbeam.network' }],
        symbol: 'GLMR',
        testnet: true,
    },
    {
        alias: 'moonbeam',
        decimals: 18,
        explorer: {
            api: { key: { hardhatEtherscanAlias: 'moonbeam', required: true }, url: 'https://api-moonbeam.moonscan.io/api' },
            browserUrl: 'https://moonscan.io/',
        },
        id: '1284',
        name: 'Moonbeam',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.api.moonbeam.network' },
            { alias: 'publicnode', rpcUrl: 'https://moonbeam-rpc.publicnode.com' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org/' },
        ],
        symbol: 'GLMR',
        testnet: false,
    },
    {
        alias: 'moonriver',
        decimals: 18,
        explorer: {
            api: {
                key: { hardhatEtherscanAlias: 'moonriver', required: true },
                url: 'https://api-moonriver.moonscan.io/api',
            },
            browserUrl: 'https://moonriver.moonscan.io/',
        },
        id: '1285',
        name: 'Moonriver',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.api.moonriver.moonbeam.network' },
            { alias: 'publicnode', rpcUrl: 'https://moonriver-rpc.publicnode.com' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org/' },
        ],
        symbol: 'MOVR',
        testnet: false,
    },
    {
        alias: 'odyssey-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://odyssey-explorer.ithaca.xyz/api' },
            browserUrl: 'https://odyssey-explorer.ithaca.xyz/',
        },
        id: '911867',
        name: 'Odyssey testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://odyssey.ithaca.xyz' }],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'oev-network',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://oev.explorer.api3.org/api/' },
            browserUrl: 'https://oev.explorer.api3.org/',
        },
        id: '4913',
        name: 'OEV Network',
        providers: [
            { alias: 'default', rpcUrl: 'https://oev.rpc.api3.org/http' },
            { alias: 'reblok', homepageUrl: 'https://reblok.io' },
        ],
        symbol: 'ETH',
        testnet: false,
    },
    {
        alias: 'opbnb-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api-opbnb-testnet.bscscan.com/api' },
            browserUrl: 'https://opbnb-testnet.bscscan.com/',
        },
        id: '5611',
        name: 'opBNB testnet',
        providers: [
            { alias: 'default', rpcUrl: 'https://opbnb-testnet-rpc.bnbchain.org/' },
            { alias: 'publicnode', rpcUrl: 'https://opbnb-testnet-rpc.publicnode.com' },
        ],
        symbol: 'BNB',
        testnet: true,
    },
    {
        alias: 'opbnb',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api-opbnb.bscscan.com/api' },
            browserUrl: 'https://opbnb.bscscan.com/',
        },
        id: '204',
        name: 'opBNB',
        providers: [
            { alias: 'default', rpcUrl: 'https://opbnb-mainnet-rpc.bnbchain.org' },
            { alias: 'publicnode', rpcUrl: 'https://opbnb-rpc.publicnode.com' },
            { alias: 'alchemy', homepageUrl: 'https://alchemy.com' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org/' },
        ],
        symbol: 'BNB',
        testnet: false,
    },
    {
        alias: 'optimism-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api-sepolia-optimism.etherscan.io/api' },
            browserUrl: 'https://sepolia-optimism.etherscan.io/',
        },
        id: '11155420',
        name: 'Optimism testnet',
        providers: [
            { alias: 'default', rpcUrl: 'https://sepolia.optimism.io' },
            { alias: 'publicnode', rpcUrl: 'https://optimism-sepolia-rpc.publicnode.com' },
        ],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'optimism',
        decimals: 18,
        explorer: {
            api: {
                key: { hardhatEtherscanAlias: 'optimisticEthereum', required: true },
                url: 'https://api-optimistic.etherscan.io/api',
            },
            browserUrl: 'https://optimistic.etherscan.io/',
        },
        id: '10',
        name: 'Optimism',
        providers: [
            { alias: 'default', rpcUrl: 'https://mainnet.optimism.io' },
            { alias: 'alchemy', homepageUrl: 'https://alchemy.com' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
            { alias: 'quicknode', homepageUrl: 'https://quicknode.com' },
        ],
        symbol: 'ETH',
        testnet: false,
    },
    {
        alias: 'polygon-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api-amoy.polygonscan.com/api' },
            browserUrl: 'https://amoy.polygonscan.com/',
        },
        id: '80002',
        name: 'Polygon testnet',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc-amoy.polygon.technology' },
            { alias: 'publicnode', rpcUrl: 'https://polygon-amoy-bor-rpc.publicnode.com' },
        ],
        symbol: 'POL',
        testnet: true,
    },
    {
        alias: 'polygon-zkevm-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api-cardona-zkevm.polygonscan.com/api' },
            browserUrl: 'https://cardona-zkevm.polygonscan.com/',
        },
        id: '2442',
        name: 'Polygon zkEVM testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://rpc.cardona.zkevm-rpc.com' }],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'polygon-zkevm',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api-zkevm.polygonscan.com/api' },
            browserUrl: 'https://zkevm.polygonscan.com/',
        },
        id: '1101',
        name: 'Polygon zkEVM',
        providers: [
            { alias: 'default', rpcUrl: 'https://zkevm-rpc.com' },
            { alias: 'alchemy', homepageUrl: 'https://alchemy.com' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
            { alias: 'quicknode', homepageUrl: 'https://quicknode.com' },
        ],
        symbol: 'ETH',
        testnet: false,
    },
    {
        alias: 'polygon',
        decimals: 18,
        explorer: {
            api: { key: { hardhatEtherscanAlias: 'polygon', required: true }, url: 'https://api.polygonscan.com/api' },
            browserUrl: 'https://polygonscan.com/',
        },
        id: '137',
        name: 'Polygon',
        providers: [
            { alias: 'default', rpcUrl: 'https://polygon-bor-rpc.publicnode.com' },
            { alias: 'alchemy', homepageUrl: 'https://alchemy.com' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
            { alias: 'quicknode', homepageUrl: 'https://quicknode.com' },
        ],
        symbol: 'POL',
        testnet: false,
    },
    {
        alias: 'rari-arbitrum-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://testnet.explorer.rarichain.org/api' },
            browserUrl: 'https://testnet.explorer.rarichain.org/',
        },
        id: '1918988905',
        name: 'RARI Chain testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://testnet.rpc.rarichain.org/http/' }],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'rari',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://mainnet.explorer.rarichain.org/api' },
            browserUrl: 'https://mainnet.explorer.rarichain.org/',
        },
        id: '1380012617',
        name: 'RARI Chain',
        providers: [{ alias: 'default', rpcUrl: 'https://mainnet.rpc.rarichain.org/http/' }],
        symbol: 'ETH',
        testnet: false,
    },
    {
        alias: 'rechain-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://testnet-explorer.rechain.dev/api' },
            browserUrl: 'https://testnet-explorer.rechain.dev/',
        },
        id: '42402',
        name: 'ReChain testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://testnet-rpc.rechain.dev/' }],
        symbol: 'VET',
        testnet: true,
    },
    {
        alias: 'ronin-testnet',
        decimals: 18,
        explorer: { browserUrl: 'https://saigon-app.roninchain.com/' },
        id: '2021',
        name: 'Ronin testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://saigon-testnet.roninchain.com/rpc' }],
        symbol: 'RON',
        testnet: true,
    },
    {
        alias: 'ronin',
        decimals: 18,
        explorer: { browserUrl: 'https://app.roninchain.com/' },
        id: '2020',
        name: 'Ronin',
        providers: [
            { alias: 'default', rpcUrl: 'https://api.roninchain.com/rpc/' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
            { alias: 'alchemy', homepageUrl: 'https://alchemy.com' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'tenderly', homepageUrl: 'https://tenderly.co/' },
        ],
        symbol: 'RON',
        testnet: false,
    },
    {
        alias: 'scroll-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api-sepolia.scrollscan.com/api' },
            browserUrl: 'https://sepolia.scrollscan.com/',
        },
        id: '534351',
        name: 'Scroll testnet',
        providers: [
            { alias: 'default', rpcUrl: 'https://sepolia-rpc.scroll.io' },
            { alias: 'publicnode', rpcUrl: 'https://scroll-sepolia-rpc.publicnode.com' },
        ],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'scroll',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api.scrollscan.com/api' },
            browserUrl: 'https://scrollscan.com/',
        },
        id: '534352',
        name: 'Scroll',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.scroll.io' },
            { alias: 'publicnode', rpcUrl: 'https://scroll-rpc.publicnode.com' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'quicknode', homepageUrl: 'https://quicknode.com' },
        ],
        symbol: 'ETH',
        testnet: false,
    },
    {
        alias: 'sei-testnet',
        decimals: 18,
        explorer: { browserUrl: 'https://testnet.seistream.app/' },
        id: '1328',
        name: 'Sei testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://evm-rpc-testnet.sei-apis.com' }],
        symbol: 'SEI',
        testnet: true,
    },
    {
        alias: 'sei',
        decimals: 18,
        explorer: { browserUrl: 'https://seitrace.com/' },
        id: '1329',
        name: 'Sei',
        providers: [
            { alias: 'default', rpcUrl: 'https://evm-rpc.sei-apis.com/' },
            { alias: 'publicnode', rpcUrl: 'https://sei-evm-rpc.publicnode.com' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
            { alias: 'quicknode', homepageUrl: 'https://quicknode.com' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
        ],
        symbol: 'SEI',
        testnet: false,
    },
    {
        alias: 'soneium-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://explorer-testnet.soneium.org/api' },
            browserUrl: 'https://explorer-testnet.soneium.org/',
        },
        id: '1946',
        name: 'Soneium testnet',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.minato.soneium.org/' },
            { alias: 'publicnode', rpcUrl: 'https://soneium-sepolia-rpc.publicnode.com' },
        ],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'soneium',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://soneium.blockscout.com/api' },
            browserUrl: 'https://soneium.blockscout.com/',
        },
        id: '1868',
        name: 'Soneium',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.soneium.org/' },
            { alias: 'publicnode', rpcUrl: 'https://soneium-rpc.publicnode.com' },
            { alias: 'alchemy', homepageUrl: 'https://alchemy.com' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'tenderly', homepageUrl: 'https://tenderly.co/' },
        ],
        symbol: 'ETH',
        testnet: false,
    },
    {
        alias: 'sonic-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api-testnet.sonicscan.org/api' },
            browserUrl: 'https://testnet.sonicscan.org/',
        },
        id: '57054',
        name: 'Sonic testnet',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.blaze.soniclabs.com' },
            { alias: 'publicnode', rpcUrl: 'https://sonic-blaze-rpc.publicnode.com:443' },
        ],
        symbol: 'S',
        testnet: true,
    },
    {
        alias: 'sonic',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api.sonicscan.org/api' },
            browserUrl: 'https://sonicscan.org/',
        },
        id: '146',
        name: 'Sonic',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.soniclabs.com' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'alchemy', homepageUrl: 'https://alchemy.com' },
            { alias: 'drpc', homepageUrl: 'https://drpc.com' },
            { alias: 'reblok', homepageUrl: 'https://reblok.io' },
        ],
        symbol: 'S',
        testnet: false,
    },
    {
        alias: 'taiko-holesky-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api-hekla.taikoscan.io/api' },
            browserUrl: 'https://hekla.taikoscan.io/',
        },
        id: '167009',
        name: 'Taiko testnet',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.hekla.taiko.xyz' },
            { alias: 'publicnode', rpcUrl: 'https://taiko-hekla-rpc.publicnode.com' },
        ],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'taiko',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api.taikoscan.io/api' },
            browserUrl: 'https://taikoscan.io/',
        },
        id: '167000',
        name: 'Taiko',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.mainnet.taiko.xyz' },
            { alias: 'publicnode', rpcUrl: 'https://taiko-rpc.publicnode.com' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
            { alias: 'reblok', homepageUrl: 'https://reblok.io' },
        ],
        symbol: 'ETH',
        testnet: false,
    },
    {
        alias: 'unichain-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api-sepolia.uniscan.xyz/api' },
            browserUrl: 'https://sepolia.uniscan.xyz/',
        },
        id: '1301',
        name: 'Unichain testnet',
        providers: [
            { alias: 'default', rpcUrl: 'https://sepolia.unichain.org' },
            { alias: 'publicnode', rpcUrl: 'https://unichain-sepolia-rpc.publicnode.com' },
        ],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'unichain',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api.uniscan.xyz/api' },
            browserUrl: 'https://uniscan.xyz/',
        },
        id: '130',
        name: 'Unichain',
        providers: [
            { alias: 'default', rpcUrl: 'https://mainnet.unichain.org/' },
            { alias: 'publicnode', rpcUrl: 'https://unichain-rpc.publicnode.com' },
            { alias: 'alchemy', homepageUrl: 'https://alchemy.com' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
            { alias: 'quicknode', homepageUrl: 'https://quicknode.com' },
        ],
        symbol: 'ETH',
        testnet: false,
    },
    {
        alias: 'world-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: false }, url: 'https://worldchain-sepolia.explorer.alchemy.com/api' },
            browserUrl: 'https://worldchain-sepolia.explorer.alchemy.com/',
        },
        id: '4801',
        name: 'World Chain testnet',
        providers: [{ alias: 'default', rpcUrl: 'https://worldchain-sepolia.g.alchemy.com/public' }],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'world',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://api.worldscan.org/api' },
            browserUrl: 'https://worldscan.org/',
        },
        id: '480',
        name: 'World Chain',
        providers: [
            { alias: 'default', rpcUrl: 'https://worldchain-mainnet.g.alchemy.com/public' },
            { alias: 'blastapi', homepageUrl: 'https://blastapi.io' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
            { alias: 'quicknode', homepageUrl: 'https://quicknode.com' },
            { alias: 'tenderly', homepageUrl: 'https://tenderly.co/' },
        ],
        symbol: 'ETH',
        testnet: false,
    },
    {
        alias: 'x-layer-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: {
                key: { required: false },
                url: 'https://www.oklink.com/api/v5/explorer/contract/verify-source-code-plugin/XLAYER_TESTNET',
            },
            browserUrl: 'https://www.okx.com/explorer/xlayer-test/',
        },
        id: '195',
        name: 'X Layer testnet',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.ankr.com/xlayer_testnet/' },
            { alias: 'public', rpcUrl: 'https://testrpc.xlayer.tech/' },
            { alias: 'okx', rpcUrl: 'https://xlayertestrpc.okx.com/' },
        ],
        symbol: 'OKB',
        testnet: true,
    },
    {
        alias: 'x-layer',
        decimals: 18,
        explorer: {
            api: {
                key: { required: false },
                url: 'https://www.oklink.com/api/v5/explorer/contract/verify-source-code-plugin/XLAYER',
            },
            browserUrl: 'https://www.okx.com/explorer/xlayer/',
        },
        id: '196',
        name: 'X Layer',
        providers: [
            { alias: 'default', rpcUrl: 'https://rpc.xlayer.tech/' },
            { alias: 'okx', rpcUrl: 'https://xlayerrpc.okx.com/' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
        ],
        symbol: 'OKB',
        testnet: false,
    },
    {
        alias: 'zircuit-sepolia-testnet',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://explorer.testnet.zircuit.com/api/contractVerifyHardhat' },
            browserUrl: 'https://explorer.testnet.zircuit.com/',
        },
        id: '48899',
        name: 'Zircuit testnet',
        providers: [
            { alias: 'default', rpcUrl: 'https://testnet.zircuit.com' },
            { alias: 'chainstack', rpcUrl: 'https://zircuit1-testnet.p2pify.com/' },
            { alias: 'liquify', rpcUrl: 'https://zircuit1-testnet.liquify.com' },
        ],
        symbol: 'ETH',
        testnet: true,
    },
    {
        alias: 'zircuit',
        decimals: 18,
        explorer: {
            api: { key: { required: true }, url: 'https://explorer.zircuit.com/api/contractVerifyHardhat' },
            browserUrl: 'https://explorer.zircuit.com/',
        },
        id: '48900',
        name: 'Zircuit',
        providers: [
            { alias: 'default', rpcUrl: 'https://mainnet.zircuit.com' },
            { alias: 'chainstack', rpcUrl: 'https://zircuit1-mainnet.p2pify.com/' },
            { alias: 'liquify', rpcUrl: 'https://zircuit1-mainnet.liquify.com' },
            { alias: 'drpc', homepageUrl: 'https://drpc.org' },
        ],
        symbol: 'ETH',
        testnet: false,
    },
];
//# sourceMappingURL=chains.js.map